<app-modal [title]="effectiveTitleKey() | translate" maxWidth="520px" (close)="onClose()">
  <p class="modal-subtitle">{{ effectiveSubtitleKey() | translate: { email: effectiveEmail() } }}</p>

  <app-pin-code
    [errorText]="effectiveErrorText()"
    [ngModel]="pinCode()"
    (ngModelChange)="onPinChange($event)"
  />

  <p class="resend-text">
    {{ 'VERIFICATION.DIDNT_GET_CODE' | translate }}
    @if (isCountdownActive()) {
      <span class="countdown">{{ 'VERIFICATION.RESEND_IN' | translate: { seconds: countdown() } }}</span>
    } @else {
      <button type="button" class="resend-btn" (click)="onResend()">{{ 'VERIFICATION.RESEND' | translate }}</button>
    }
  </p>

  <app-button
    [label]="effectiveButtonKey() | translate"
    [disabled]="isVerifyDisabled()"
    [loading]="effectiveLoading()"
    (click)="onVerify()"
  />
</app-modal>
